import React from 'react';
import { Modal } from 'reactstrap';

import { ApiContext } from 'src/utils/ApiContext';

export default (props) => {
  const context = React.useContext(ApiContext);

  return (
    <Modal
      isOpen={context.showWaiting}
      toggle={() => context.setShowWaiting(true)}
      zIndex={1}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: 20,
          paddingBottom: 20,
        }}
      >
        {'執行中...請稍等一下'}
      </div>
    </Modal>
  );
};
